import InclusionType from "./enums/InclusionType";

class SpatialRelation {
  constructor(
    public id_reference: number,
    public id_included: number,
    public id_user: number,
    public transformation: string,
    public inclusion_type: InclusionType,
    public id?: number | undefined,
    public created_on?: string | undefined
  ) {}

  public static EmptyInstance(): SpatialRelation {
    return new SpatialRelation(-1, -1, -1, "", InclusionType.PART_OF);
  }
}

export default SpatialRelation;
